export enum OriginType {
    BOOTCAMP='bootcamp',
    ACCELERATION='acceleration',
    JOB='job',
}